/* --- START: src/demoData.js --- */
import { getLocalDateString } from './constants';

const TODAY = new Date();
const YESTERDAY = new Date(Date.now() - 86400000);
const TWO_DAYS_AGO = new Date(Date.now() - 172800000);

// Helper to format ISO strings relative to now
const relDate = (daysAgo) => {
    const d = new Date();
    d.setDate(d.getDate() - daysAgo);
    return d.toISOString();
};

export const DEMO_STATE = {
    userMeta: {
        onboarding_complete: true,
        is_demo_active: true, // Flag to show the banner
        current_streak_days: 4,
        last_completed_day: getLocalDateString(YESTERDAY)
    },
    goals: {
        daily_rule_target: 5,
        target_mastery_date: "2026-02-24", // Default Bar Exam
        study_days: ["monday", "tuesday", "wednesday", "thursday", "friday"],
        mix_mode: true
    },
    docket: {
        schedule: [
            {
                date: getLocalDateString(TODAY),
                is_break_day: false,
                metrics: { learned_count: 0, quiz_count: 0 },
                targets: { learn: 3, quiz: 2 },
                phases: [
                    { phase_type: 'MORNING_DE_NOVO', status: 'pending', item_ids: [] }, // Populated dynamically by srsService
                    { phase_type: 'LEARN_NEW_RULES', status: 'pending', item_ids: [] },
                    { phase_type: 'AFTERNOON_DE_NOVO', status: 'pending', item_ids: [] }
                ]
            }
        ]
    },
    "rulesProgress": {
        "018c900d-e478-4bdb-a437-1ad95f77c90f": {
            "keynote": "IIED intent: reckless as to effect.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T19:56:58.526Z",
                "learningStepIndex": -1
            }
        },
        "06b3569c-8405-4aaf-bbf4-d2ef3915d70d": {
            "keynote": "D must have apparent ability to carry out threat: immediate contact, not future harm.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T19:46:24.231Z",
                "learningStepIndex": -1
            }
        },
        "0bc13ad0-7fb7-4e81-8a9c-9244db4282a6": {
            "keynote": "Bounded area: limited in all directions, no reasonable means of escape known.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T19:54:47.799Z",
                "learningStepIndex": -1
            }
        },
        "0dd6c100-6bab-4ff5-ba0a-ff8c2e34039b": {
            "keynote": "Intent: 1) to bring about consequences or 2) know with substantial certainty conseqeunces will result.  Motive ≠ intent.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T17:26:29.561Z",
                "learningStepIndex": -1
            },
            "attempt_history": [
                {
                    "source": "quiz",
                    "feedback": {
                        "comments": [
                            {
                                "id": 1,
                                "feedback": "Minor typo: 'pedestrian'."
                            },
                            {
                                "id": 2,
                                "feedback": "Minor typo: 'certainty'."
                            },
                            {
                                "id": 3,
                                "feedback": "Good observation, but be careful to specify the object of the intent for battery. The intent must be to cause harmful/offensive contact *with the plaintiff's person*, not just to perform an action (like hitting the ball)."
                            },
                            {
                                "id": 4,
                                "feedback": "Minor typo: 'that'."
                            },
                            {
                                "id": 5,
                                "feedback": "Minor typo: 'times'."
                            },
                            {
                                "id": 6,
                                "feedback": "Minor typos: 'known' and 'was walking'."
                            },
                            {
                                "id": 7,
                                "feedback": "Minor typo: 'substantially'."
                            }
                        ],
                        "score_suggestion": 5,
                        "annotated_user_answer_html": "The issue is whether Player is liable for battery for unintentionally hitting <span id=\"1\">pedestrial</span> with a baseball. Battery requires that the defendant intentionally cause a harmful or offensive contact to the plaintiff's person. Intent for battery requires either knowledge to a substantial <span id=\"2\">certianty</span> or intent to cause the harmful contact. <span id=\"3\">Here, the player did intend to hit the ball, and there was a harmful or offensive contact on the pedestrian.</span> However, the player did not have knowledge to a substantial certainty <span id=\"4\">taht</span> the pedestrian would be hit because the ball has only been hit out of the park a few <span id=\"5\">tiems</span> in the stadium's history. Also, more importantly, the player could not have <span id=\"6\">know the pedestrian nwas walking</span> on the sidewalk outside, so the player could not have been <span id=\"7\">susbtantially</span> certain nor had the intent to cause the harmful contact. Therefore, the player is not liable."
                    },
                    "sourceId": "9626c398-90e5-4cf5-b33c-ee0a73a7ddbb",
                    "timestamp": "2025-12-30T17:34:03.555Z",
                    "userScore": 5,
                    "userAttempt": "The issue is whether Player is liable for battery for unintentionally hitting pedestrial with a baseball.  Battery requires that the defendant intentionally cause a harmful or offensive contact to the plaintiff's person.  Intent for battery requires either knowledge to a substantial certianty or intent to cause the harmful contact.  Here, the player did intend to hit the ball, and there was a harmful or offensive contact on the pedestrian.  However, the player did not have knowledge to a substantial certainty taht the pedestrian would be hit because the ball has only been hit out of the park a few tiems in the stadium's history.  Also, more importantly, the player could not have know the pedestrian nwas walking on the sidewalk outside, so the player could not have been susbtantially certain nor had the intent to cause the harmful contact.  Therefore, the player is not liable."
                }
            ]
        },
        "165915f4-c2cf-44d5-99e5-b8359bfbf086": {
            "keynote": "Harmful: injury, pain, disfigurement.\nOffensive: reasonable person of ordinary sensibilities",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T19:43:30.019Z",
                "learningStepIndex": -1
            }
        },
        "17a9c76e-12d9-4ca3-9df6-72a3997abbad": {
            "keynote": "Types of Confinement: 1) physical barriers, 2) physical force against P or immediate family, 3) in/direct threats of force, or 4) invalid use of legal authority.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T19:48:03.361Z",
                "learningStepIndex": -1
            }
        },
        "2d37dfaa-fa54-4224-9693-6271ee967956": {
            "keynote": "Ex/O conduct: transcend all bounds of decency.  Insults/indignities not enough unless: 1) special relationship, or 2) ∆ knows of π's particular sensitivity.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T19:56:35.727Z",
                "learningStepIndex": -1
            }
        },
        "42a62f8a-e9f0-4f3d-93c9-40d7be4bfe8a": {
            "keynote": "Assault: 1) intentional act 2) creates reasonable apprehension of 3) imminent harmful or offensive contact.  Apprehension must be reasonable.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T19:45:11.615Z",
                "learningStepIndex": -1
            }
        },
        "60cbcc99-c0c6-4177-b2b5-fb3b90d9c9ce": {
            "keynote": "FI: 1) intentional act or omission, 2) confines or restrains 3) bounded area, 4) P aware OR harmed.  Time is immaterial.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T19:47:17.511Z",
                "learningStepIndex": -1
            }
        },
        "92eacbbe-6a16-4f03-95e1-dcbf353e9aa3": {
            "keynote": "battery: 1) intentional act, 2) harmful or offensive contact, 3) plaintiff's person.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T17:29:05.461Z",
                "learningStepIndex": -1
            },
            "attempt_history": [
                {
                    "source": "quiz",
                    "feedback": {
                        "comments": [
                            {
                                "id": 1,
                                "feedback": "Minor typo: 'pedestrian'."
                            },
                            {
                                "id": 2,
                                "feedback": "Minor typo: 'certainty'."
                            },
                            {
                                "id": 3,
                                "feedback": "Good observation, but be careful to specify the object of the intent for battery. The intent must be to cause harmful/offensive contact *with the plaintiff's person*, not just to perform an action (like hitting the ball)."
                            },
                            {
                                "id": 4,
                                "feedback": "Minor typo: 'that'."
                            },
                            {
                                "id": 5,
                                "feedback": "Minor typo: 'times'."
                            },
                            {
                                "id": 6,
                                "feedback": "Minor typos: 'known' and 'was walking'."
                            },
                            {
                                "id": 7,
                                "feedback": "Minor typo: 'substantially'."
                            }
                        ],
                        "score_suggestion": 5,
                        "annotated_user_answer_html": "The issue is whether Player is liable for battery for unintentionally hitting <span id=\"1\">pedestrial</span> with a baseball. Battery requires that the defendant intentionally cause a harmful or offensive contact to the plaintiff's person. Intent for battery requires either knowledge to a substantial <span id=\"2\">certianty</span> or intent to cause the harmful contact. <span id=\"3\">Here, the player did intend to hit the ball, and there was a harmful or offensive contact on the pedestrian.</span> However, the player did not have knowledge to a substantial certainty <span id=\"4\">taht</span> the pedestrian would be hit because the ball has only been hit out of the park a few <span id=\"5\">tiems</span> in the stadium's history. Also, more importantly, the player could not have <span id=\"6\">know the pedestrian nwas walking</span> on the sidewalk outside, so the player could not have been <span id=\"7\">susbtantially</span> certain nor had the intent to cause the harmful contact. Therefore, the player is not liable."
                    },
                    "sourceId": "9626c398-90e5-4cf5-b33c-ee0a73a7ddbb",
                    "timestamp": "2025-12-30T17:34:03.555Z",
                    "userScore": 5,
                    "userAttempt": "The issue is whether Player is liable for battery for unintentionally hitting pedestrial with a baseball.  Battery requires that the defendant intentionally cause a harmful or offensive contact to the plaintiff's person.  Intent for battery requires either knowledge to a substantial certianty or intent to cause the harmful contact.  Here, the player did intend to hit the ball, and there was a harmful or offensive contact on the pedestrian.  However, the player did not have knowledge to a substantial certainty taht the pedestrian would be hit because the ball has only been hit out of the park a few tiems in the stadium's history.  Also, more importantly, the player could not have know the pedestrian nwas walking on the sidewalk outside, so the player could not have been susbtantially certain nor had the intent to cause the harmful contact.  Therefore, the player is not liable."
                }
            ]
        },
        "adf00860-8960-4d02-afba-3e78c90161c2": {
            "keynote": "Words alone not sufficient.  Requires overt act.  Words can NEGATE assault by making app unreasonable.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T19:45:47.031Z",
                "learningStepIndex": -1
            }
        },
        "bcc77dd1-dff8-4e8c-a97c-ffb6c5067f54": {
            "keynote": "Plaintiff's person: anything connected to plaintiff.  Actual damages not required, nominal for the offensive touching.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T19:44:19.417Z",
                "learningStepIndex": -1
            }
        },
        "c82c9249-ee1f-4be6-a7e9-683bbfc5a6e4": {
            "keynote": "PF intentional tort: 1) act, 2) intent, 3) causation.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T17:24:49.243Z",
                "learningStepIndex": -1
            }
        },
        "d25988e0-e4dc-486a-ac98-93c50824b421": {
            "keynote": "IIED: 1) ex and outrageous conduct, 2) intentionally or recklessly causes, 4) p suffer sever emotional distress.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T19:55:35.950Z",
                "learningStepIndex": -1
            }
        },
        "dd396ffc-09fb-416b-879a-7229bfb684ae": {
            "keynote": "Transferred intent for intend tort against one but 1) diff tort, 2) different victim, 3) diff tort against diff victim.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T17:27:43.580Z",
                "learningStepIndex": -1
            }
        },
        "e009ad0a-fc8f-4513-9b9e-af8b5efcdac9": {
            "keynote": "IIED - bystander may recover if: 1) present when injury, 2) close relative, AND 3) ∆ knew of presence AND relationship.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T19:58:37.878Z",
                "learningStepIndex": -1
            }
        },
        "e20ce505-ec01-4c26-9a23-dbb1f343d4d5": {
            "keynote": "ABFTT: assault, battery, false imprisonment, trespass land, trespass chattels.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T17:28:30.497Z",
                "learningStepIndex": -1
            }
        },
        "e22a15a9-8e78-435c-a73a-2c0b2d790cd3": {
            "keynote": "IIED damages: severe emotional distress, physical symptoms NOT required.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T19:57:32.027Z",
                "learningStepIndex": -1
            }
        },
        "eb122d74-0dce-40b1-8021-60226b984509": {
            "keynote": "act = volitional movement",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T17:25:08.277Z",
                "learningStepIndex": -1
            }
        },
        "ec42dca9-ecac-473f-9331-608d636cc3e1": {
            "keynote": "Battery intent: 1) purpose of causing contact, or 2) knowledge to substantial certainty contact will result.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T17:29:42.478Z",
                "learningStepIndex": -1
            },
            "attempt_history": [
                {
                    "source": "quiz",
                    "feedback": {
                        "comments": [
                            {
                                "id": 1,
                                "feedback": "Minor typo: 'pedestrian'."
                            },
                            {
                                "id": 2,
                                "feedback": "Minor typo: 'certainty'."
                            },
                            {
                                "id": 3,
                                "feedback": "Good observation, but be careful to specify the object of the intent for battery. The intent must be to cause harmful/offensive contact *with the plaintiff's person*, not just to perform an action (like hitting the ball)."
                            },
                            {
                                "id": 4,
                                "feedback": "Minor typo: 'that'."
                            },
                            {
                                "id": 5,
                                "feedback": "Minor typo: 'times'."
                            },
                            {
                                "id": 6,
                                "feedback": "Minor typos: 'known' and 'was walking'."
                            },
                            {
                                "id": 7,
                                "feedback": "Minor typo: 'substantially'."
                            }
                        ],
                        "score_suggestion": 5,
                        "annotated_user_answer_html": "The issue is whether Player is liable for battery for unintentionally hitting <span id=\"1\">pedestrial</span> with a baseball. Battery requires that the defendant intentionally cause a harmful or offensive contact to the plaintiff's person. Intent for battery requires either knowledge to a substantial <span id=\"2\">certianty</span> or intent to cause the harmful contact. <span id=\"3\">Here, the player did intend to hit the ball, and there was a harmful or offensive contact on the pedestrian.</span> However, the player did not have knowledge to a substantial certainty <span id=\"4\">taht</span> the pedestrian would be hit because the ball has only been hit out of the park a few <span id=\"5\">tiems</span> in the stadium's history. Also, more importantly, the player could not have <span id=\"6\">know the pedestrian nwas walking</span> on the sidewalk outside, so the player could not have been <span id=\"7\">susbtantially</span> certain nor had the intent to cause the harmful contact. Therefore, the player is not liable."
                    },
                    "sourceId": "9626c398-90e5-4cf5-b33c-ee0a73a7ddbb",
                    "timestamp": "2025-12-30T17:34:03.555Z",
                    "userScore": 5,
                    "userAttempt": "The issue is whether Player is liable for battery for unintentionally hitting pedestrial with a baseball.  Battery requires that the defendant intentionally cause a harmful or offensive contact to the plaintiff's person.  Intent for battery requires either knowledge to a substantial certianty or intent to cause the harmful contact.  Here, the player did intend to hit the ball, and there was a harmful or offensive contact on the pedestrian.  However, the player did not have knowledge to a substantial certainty taht the pedestrian would be hit because the ball has only been hit out of the park a few tiems in the stadium's history.  Also, more importantly, the player could not have know the pedestrian nwas walking on the sidewalk outside, so the player could not have been susbtantially certain nor had the intent to cause the harmful contact.  Therefore, the player is not liable."
                }
            ]
        },
        "ee5afa1c-15e8-4a70-91fb-00715175dc89": {
            "keynote": "Causation: substantial factor in bringing about injury",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T17:27:00.993Z",
                "learningStepIndex": -1
            }
        },
        "f318d662-e238-495a-bd4d-c000f08ada20": {
            "keynote": "Relative Requirement Exception Bystander IIED: if ∆'s purpose was to cause distress, can recover even if NOT a relative.",
            "srs_data": {
                "lapses": 0,
                "isLeech": false,
                "burnCount": 0,
                "easeFactor": 2.5,
                "nextDueDate": "2025-12-31T05:00:00.000Z",
                "repetitions": 0,
                "currentInterval": 1,
                "lastReviewedDate": "2025-12-30T19:59:20.345Z",
                "learningStepIndex": -1
            }
        }
    },
    // Mock Activity Log for graphs
    userStats: {
        daily_activity: [
            { date: relDate(3), rules_learned: 5, reviews: 10 },
            { date: relDate(2), rules_learned: 3, reviews: 15 },
            { date: relDate(1), rules_learned: 4, reviews: 12 }
        ]
    },
    "quizzesProgress": {
        "9626c398-90e5-4cf5-b33c-ee0a73a7ddbb": {
            "status": "mastered",
            "high_score": 5,
            "last_attempt": "2025-12-30T17:34:03.555Z",
            "attempt_history": [
                {
                    "feedback": {
                        "comments": [
                            {
                                "id": 1,
                                "feedback": "Minor typo: 'pedestrian'."
                            },
                            {
                                "id": 2,
                                "feedback": "Minor typo: 'certainty'."
                            },
                            {
                                "id": 3,
                                "feedback": "Good observation, but be careful to specify the object of the intent for battery. The intent must be to cause harmful/offensive contact *with the plaintiff's person*, not just to perform an action (like hitting the ball)."
                            },
                            {
                                "id": 4,
                                "feedback": "Minor typo: 'that'."
                            },
                            {
                                "id": 5,
                                "feedback": "Minor typo: 'times'."
                            },
                            {
                                "id": 6,
                                "feedback": "Minor typos: 'known' and 'was walking'."
                            },
                            {
                                "id": 7,
                                "feedback": "Minor typo: 'substantially'."
                            }
                        ],
                        "score_suggestion": 5,
                        "annotated_user_answer_html": "The issue is whether Player is liable for battery for unintentionally hitting <span id=\"1\">pedestrial</span> with a baseball. Battery requires that the defendant intentionally cause a harmful or offensive contact to the plaintiff's person. Intent for battery requires either knowledge to a substantial <span id=\"2\">certianty</span> or intent to cause the harmful contact. <span id=\"3\">Here, the player did intend to hit the ball, and there was a harmful or offensive contact on the pedestrian.</span> However, the player did not have knowledge to a substantial certainty <span id=\"4\">taht</span> the pedestrian would be hit because the ball has only been hit out of the park a few <span id=\"5\">tiems</span> in the stadium's history. Also, more importantly, the player could not have <span id=\"6\">know the pedestrian nwas walking</span> on the sidewalk outside, so the player could not have been <span id=\"7\">susbtantially</span> certain nor had the intent to cause the harmful contact. Therefore, the player is not liable."
                    },
                    "timestamp": "2025-12-30T17:34:03.555Z",
                    "userScore": 5,
                    "userAttempt": "The issue is whether Player is liable for battery for unintentionally hitting pedestrial with a baseball.  Battery requires that the defendant intentionally cause a harmful or offensive contact to the plaintiff's person.  Intent for battery requires either knowledge to a substantial certianty or intent to cause the harmful contact.  Here, the player did intend to hit the ball, and there was a harmful or offensive contact on the pedestrian.  However, the player did not have knowledge to a substantial certainty taht the pedestrian would be hit because the ball has only been hit out of the park a few tiems in the stadium's history.  Also, more importantly, the player could not have know the pedestrian nwas walking on the sidewalk outside, so the player could not have been susbtantially certain nor had the intent to cause the harmful contact.  Therefore, the player is not liable."
                }
            ]
        }
    }
};
/* --- END: src/demoData.js --- */